import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import { ReportsBuilderRoutes } from '../../../routes/HomeRoutes/ReportsBuilderRoutes';

export const ReportsBuilderLayout = () => (
  <SwitchRoute routes={ReportsBuilderRoutes} />
);
